"use strict";
/**
 * Theme Toggle Handler
 *
 * Wires the Dark Mode switch in the settings modal.
 *
 * The switch is binary but the preference has three states (system/light/dark).
 * It therefore shows the *currently resolved* theme, and flipping it writes an
 * explicit override — matching the agreed behaviour: follow the OS until the
 * user says otherwise, then honour that choice and persist it.
 *
 * Unlike the rest of the settings modal this applies immediately and persists
 * itself, rather than waiting for the form's Save. A theme is a display
 * preference, not a trading setting, and previewing it behind a Save button
 * would be poor UX.
 *
 * @module handlers/theme-handler
 */
Object.defineProperty(exports, "__esModule", { value: true });
exports.setupThemeToggle = setupThemeToggle;
const theme_service_1 = require("../services/theme-service");
const TOGGLE_ID = "dark-mode-toggle";
/**
 * Apply the stored theme, sync the switch, and follow the OS while no
 * explicit choice is set. Called once from `initApp`.
 */
function setupThemeToggle() {
    // theme-init.js already stamped any explicit preference before first
    // paint; this re-applies it so the client and the DOM agree.
    (0, theme_service_1.initTheme)();
    const toggle = document.getElementById(TOGGLE_ID);
    if (toggle) {
        toggle.checked = (0, theme_service_1.getResolvedTheme)() === "dark";
        toggle.addEventListener("change", () => {
            (0, theme_service_1.setThemePreference)(toggle.checked ? "dark" : "light");
        });
    }
    // Keep the switch honest if the OS flips while we are still following it.
    (0, theme_service_1.watchSystemTheme)((theme) => {
        const el = document.getElementById(TOGGLE_ID);
        if (el)
            el.checked = theme === "dark";
    });
}
